<template>
  <div class="is-main-content" :class="{ 'no-scroll': !messages.length }">
    <error-msg-component
      :messages="messages"
      :error="error"
      title="Un problème est survenu"
      :withEmplyFields="true"
      :messagesChampsVide="[]"
      :champsVide="[]"
      @close="error = $event"/>
    <div class="columns is-fullheight">
      <div class="column">
        <div class="container is-fluid">
          <div class="level">
            <div class="level-left">
              <a href="javascript:history.back()">
                <div class="field is-horizontal">
                  <div class="align-center">
                    <b-icon icon="arrow-left" type="is-primary"></b-icon>
                  </div>
                  <div class="field">
                    <p class="is-size-6 has-text-default"
                        style="margin-left:20px;"
                        v-if="getIsModif">
                      <strong class="is-size-4">Modification de l'opportunité</strong> <br>
                      {{themeCampagne}}
                    </p>
                    <p class="is-size-6 has-text-default"
                        style="margin-left:20px;"
                        v-else-if="getIsDuplicate">
                      <strong class="is-size-4">Duplication de l'opportunité</strong> <br>
                      {{themeCampagne}}
                    </p>
                    <div class="is-size-6 has-text-default"
                        style="margin-left:20px;"
                        v-else>
                      <strong class="is-size-4">Création d'opportunité</strong> <br>
                      Nouvelle opportunité
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="level-rigth">
              <div class="buttons">
                <button
                  class="button"
                  @click="viderPanier()"
                  :disabled="disabled">
                  Vider le panier
                </button>
                <b-button
                  @click="isPrevisionActive = true">
                  Prévisualiser
                </b-button>
                <b-tooltip
                  position="is-left"
                  type="is-danger"
                  :active="!!errorValiderDefinitivement.length">
                  <b-button
                    type="is-primary"
                    @click="envoyerOpportunite()"
                    :disabled="!!errorValiderDefinitivement.length">
                    Sauvegarder l’opportunité
                  </b-button>
                  <template v-slot:content>
                    <div class="content m-2">
                      <li
                        v-for="(err, index) in errorValiderDefinitivement"
                        :key="index">
                        {{err}}
                      </li>
                    </div>
                  </template>
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="component_panier">
          <div class="section py-0 level">
            <div class="level-left is-align-items-flex-end">
              <div class="level-item">
                <app-client/>
              </div>
              <div class="level-item">
                <GestionInfoUserOpp :agenceIdOpp="!!panier.agenceId ? panier.agenceId : ''"/>
              </div>
            </div>
            <div class="level-right">
              <b-tabs type="is-toggle" class="ml-30" v-model="tabValue" v-if="getShowProduit">
                <b-tab-item label="Produits" class="is-paddingless"
                      icon="format-list-bulleted">
                </b-tab-item>
                <b-tab-item label="Cartographie" class="column">
                </b-tab-item>
              </b-tabs>
            </div>
          </div>
          <app-produits v-if="tabValue === 0" :produits="panier.produits"
                        :panier="panier"
                        :disabled="disabled"/>
          <app-carte v-if="tabValue === 1" :tabValue="tabValue"/>
        </div>
      </div>
      <app-envoyer-opportunite/>
      <b-modal v-model="isComponentAjoutClientActive"
               has-modal-card
               class="modal">
        <app-ajout-client/>
      </b-modal>
      <modal-prevision
        v-if="isPrevisionActive"
        @close="isPrevisionActive = false"
        @accessParam="OuvreParam()"
        :userEmail="userEmailDestination"
        :opportunite="panier"/>
      <b-modal v-model="isParamActive"
                has-modal-card
                class="modal">
        <modal-parametre @close="isParamActive = false"/>
      </b-modal>
      <b-modal v-model="isComponentViderPanier"
              has-modal-card class="modal">
        <app-vider-panier
          @close="closeModalViderPanier"/>
      </b-modal>
    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import * as typesClient from '@/store/modules/client-mutation-type';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import {
  creerDevisOuNon,
  updateOppWithDevis,
  addOppPdfToDevis,
  validFacesReseauxTempo,
} from '@/services/panier/devis';
import viderPanier from '@/components/creationOpportunite/panier/viderPanier';
import { PAGE_DEFAULT } from '@/router/routerConf';
import validationDevisCommande from '@/services/devisCommandes/validation';
import validationLignesCommande from '@/services/devisCommandes/validationVentePartielle';
import * as devisConf from '@/configuration/devisConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { removeDuplicateMsgError } from '@/services/validation/validation';
import estClientBloque from '@/services/client/estClientBloque';
import levelString from '@/services/client/levelToString';
import ajoutClient from './client/ajoutClient';
import client from './client/client';
import produits from './composantsProduits/produits';
import envoyerOpportunite from './envoyerOpportunite/index';
import modalPrevision from './previsualiserOpportunite/modalPrevision';
import modalParametre from './previsualiserOpportunite/modalParametre';
import ListeFacesReseauTempo from './composantsProduits/venteReseauxTempo/consultation/listeFacesReseauTempo';
import carte from './carte';
import GestionInfoUserOpp from './gestionInfoUserOpp';


const Panier = createNamespacedHelpers('panier');
const User = createNamespacedHelpers('user');
const Modal = createNamespacedHelpers('modal');
const Client = createNamespacedHelpers('client');
const Parametrages = createNamespacedHelpers('parametrage');
const Opportunites = createNamespacedHelpers('opportunites');

export default {
  name: 'CreationOpportunitePanier',
  components: {
    appAjoutClient: ajoutClient,
    appClient: client,
    appProduits: produits,
    appEnvoyerOpportunite: envoyerOpportunite,
    appListeFacesReseauTempo: ListeFacesReseauTempo,
    appCarte: carte,
    appViderPanier: viderPanier,
    modalPrevision,
    modalParametre,
    GestionInfoUserOpp,
    errorMsgComponent,
  },
  data() {
    return {
      disabled: false,
      keepFirst: false,
      openOnFocus: false,
      nomClient: '',
      tabValue: 0,
      userEmailDestination: '',
      theme: '',
      isPrevisionActive: false,
      isParamActive: false,
      isComponentViderPanier: false,
      messages: [],
      error: false,
    };
  },
  mounted() {
    this.userEmailDestination = this.userEmail;
    this.theme = this.getThemeCampagne;
  },
  watch: {
    panier: {
      handler() {
        this.updatePrixGlobal();
      },
      immediate: true,
    },
  },
  computed: {
    ...Panier.mapGetters({
      getContactPanier: 'contactPanier',
      getClientPanier: 'clientPanier',
      getInsererPdf: 'insererPdf',
      getDateValidite: 'dateValidite',
      getThemeCampagne: 'themeCampagne',
      getPanier: 'panier',
      getShowProduit: 'showProduit',
      getIsModif: 'isModif',
      getIdOppModif: 'idOppModif',
      getAdressesProduitsPanier: 'adressesProduitsPanier',
      getIsDuplicate: 'isDuplicate',
      msgsErreurs: 'msgsErreurs',
    }),
    ...Client.mapGetters({
      getClient: 'client',
    }),
    ...User.mapGetters({
      userEmail: 'userEmail',
      agences: 'agences',
      agenceId: 'agenceId',
      site: 'site',
    }),
    ...Modal.mapGetters({
      getIsComponentEnregistrerOpportuniteActive: 'isComponentEnregistrerOpportuniteActive',
      getIsComponentAjoutClientActive: 'isComponentAjoutClientActive',
    }),
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
    contactPanier: {
      get() {
        return this.getContactPanier;
      },
      set(value) {
        this.setContactPanier(value);
      },
    },
    clientPanier: {
      get() {
        return this.getClientPanier;
      },
      set(value) {
        this.setClientPanier(value);
      },
    },
    client: {
      get() {
        return this.getClient;
      },
      set(value) {
        this.setClient(value);
      },
    },
    isComponentEnregistrerOpportuniteActive: {
      get() {
        return this.getIsComponentEnregistrerOpportuniteActive;
      },
      set(value) {
        this.setIsComponentEnregistrerOpportuniteActive(value);
      },
    },
    isComponentAjoutClientActive: {
      get() {
        return this.getIsComponentAjoutClientActive;
      },
      set(value) {
        this.setIsComponentAjoutClient(value);
      },
    },
    themeCampagne: {
      get() {
        return this.getThemeCampagne;
      },
      set(value) {
        this.setThemeCampagne(value);
      },
    },
    dateValidite: {
      get() {
        return this.getDateValidite;
      },
      set(value) {
        this.setDateValidite(value);
      },
    },
    panier: {
      get() {
        return this.getPanier;
      },
      set(value) {
        this.setPanier(value);
      },
    },
    isCreerDevis() {
      return creerDevisOuNon(this.panier.produits);
    },
    messageClientBloque() {
      if (!estClientBloque(this.clientPanier)) return '';
      return `Le client ${this.clientPanier.nomCommercial} est ${levelString(this.clientPanier.blocageLevel)}, l'opportunité ne peut pas être enregistrée.`;
    },
    errorValiderDefinitivement() {
      const errors = [];
      if (this.messageClientBloque) errors.push(this.messageClientBloque);
      if (!this.isAffixe2) return errors;
      if (this.isCreerDevis) {
        if (!this.clientPanier || !this.clientPanier.nomCommercial) {
          errors.push('Veuillez indiquer un client ou un prospect');
        }
        if ((this.panier.produits.panneauxNumeriques.length
          || this.panier.produits.reseauxNumeriques.length) && store.getters['user/site'] !== 'vildeo') {
          if (this.panier.devisObject) {
            errors.push(`
              L'opportunité est déjà associée au devis ${this.panier.devisObject.code},
              vous ne pouvez pas ajouter d'écran ou réseaux numériques dans cette opportunité.
            `);
          } else {
            errors.push('La transformation d\'une opportunité en devis n\'est pas possible avec les écrans ou réseaux numériques.');
          }
        }
      }
      return errors;
    },
  },
  methods: {
    ...Panier.mapMutations({
      setContactPanier: typesPanier.SET_CONTACT_PANIER,
      setClientPanier: typesPanier.SET_CLIENT_PANIER,
      setDateValidite: typesPanier.SET_DATE_VALIDITE,
      setThemeCampagne: typesPanier.SET_THEME_CAMPAGNE,
      setResetPanier: typesPanier.RESET_PANIER,
      setPanier: typesPanier.SET_PANIER,
      updatePrixGlobal: typesPanier.UPDATE_PRIX_GLOBAL,
    }),
    ...Modal.mapMutations({
      setIsComponentEnregistrerOpportuniteActive:
      typesModal.SET_IS_COMPONENT_ENREGISTRER_OPPORTUNITE_ACTIVE,
      setIsComponentAjoutClient: typesModal.SET_IS_COMPONENT_AJOUT_CLIENT,
    }),
    ...Client.mapMutations({
      setClient: typesClient.SET_CLIENT,
    }),
    ...Panier.mapActions({
      actionGenererOpportuniteData: 'genererOpportuniteData',
      actionsEnvoyerOpportunite: 'envoyerOpportunite',
      actionsCreerReseauPersonnalise: 'creerReseauPersonnalise',
      actionsPrevisualiserOpportunite: 'previsualiserOpportunite',
    }),
    ...Opportunites.mapActions({
      actionsGenererDevis: 'genererDevisOpp',
    }),
    async envoyerOpportunite() {
      this.error = false;
      let isNewDevisCommande = false;
      this.messages = [];
      let idOpp = '';
      if (this.messageClientBloque) {
        gestionErreur(this.messageClientBloque);
        return;
      }
      if (!this.agenceId && this.isAffixe2) {
        this.$buefy.toast.open({
          duration: 5000,
          message: 'Veuillez selectionner une agence',
          position: 'is-bottom',
          type: 'is-danger',
        });
        return;
      }
      if (this.panier.produits.panneauxLc.length !== 0 ||
        this.panier.produits.reseauxTempo.length !== 0 ||
        this.panier.produits.reseauxLc.length !== 0 ||
        this.panier.produits.panneauxNumeriques.length !== 0 ||
        this.panier.produits.reseauxNumeriques.length !== 0 ||
        this.panier.produits.reseauxPersonnalise.length !== 0) {
        const loadingComponent = this.$buefy.loading.open({ container: null });
        const produitsReseaux = cloneDeep(this.panier.produits.reseauxTempo);
        try {
          if (!this.getIsModif || (this.getIsModif && !this.panier.devisObject)) {
            isNewDevisCommande = true;
            idOpp = (await this.creerOpportunite()).id;
          } else {
            isNewDevisCommande = false;
            idOpp = this.getIdOppModif;
            await this.modifierOpportunite();
          }
          loadingComponent.close();
          if (idOpp) this.$router.push({ name: 'detailopportunite', params: { id: idOpp } });
        } catch (e) {
          loadingComponent.close();
          if (e.response && e.response.data && e.response.data.error) {
            this.error = true;
            validationDevisCommande(
              e.response,
              this.messages,
              isNewDevisCommande,
              devisConf.TYPE_DEVIS,
              produitsReseaux);
            validationLignesCommande(e.response, this.messages, produitsReseaux);
            this.messages = removeDuplicateMsgError(this.messages);
            return;
          }
          if (idOpp) this.$router.push({ name: 'detailopportunite', params: { id: idOpp } });
        }
      } else {
        gestionErreur('Aucun produit dans votre panier');
      }
    },
    async creerOpportunite() {
      const res = await this.actionsEnvoyerOpportunite({});

      let isCreerDevis = creerDevisOuNon(res.opp.data.produits);
      if (isCreerDevis) isCreerDevis = validFacesReseauxTempo(res.opp.data.produits.reseauxTempo);

      if (!!res.opp && isCreerDevis) {
        res.opp.etatBrouillon = true;
        const resultDevis = await this.actionsGenererDevis(res.opp);
        if (resultDevis.id) {
          await updateOppWithDevis(resultDevis, res.opp);
          await addOppPdfToDevis(isCreerDevis, res.opp, resultDevis.id);
        }
      }
      return { id: res.opp ? res.opp.id : '' };
    },
    async modifierOpportunite() {
      const opp = await this.actionGenererOpportuniteData();
      if (!validFacesReseauxTempo(opp.data.produits.reseauxTempo)) throw new Error('Erreur de validation sur la sélection de faces réseau tempo');

      if (opp.data.devisObject) {
        opp.etatBrouillon = true;
        const resultDevis = await this.actionsGenererDevis(opp);

        if (resultDevis.id) {
          const res = await this.actionsEnvoyerOpportunite({ opp });
          await updateOppWithDevis(resultDevis, res.opp);
          await addOppPdfToDevis(false, res.opp, resultDevis.id);
        }
      } else {
        await this.actionsEnvoyerOpportunite({
          userEmail: this.userEmailDestination,
          opp,
        });
      }
    },
    closeMail() {
      if (!this.isComponentEnregistrerOpportuniteActive) {
        this.resetPanier();
      }
    },
    OuvreParam() {
      this.isPrevisionActive = false;
      this.isParamActive = true;
    },
    resetPanier() {
      this.clientPanier = null;
      this.contactPanier = null;
      this.client = null;
      this.setResetPanier();
    },
    annuler() {
      this.resetPanier();
      this.$router.go(-1);
    },
    async closeModalViderPanier(ok) {
      this.isComponentViderPanier = false;
      const isModif = this.getIsModif;
      if (ok) {
        this.resetPanier();
        if (isModif) {
          this.$router.go(-1);
        } else this.$router.push(PAGE_DEFAULT);
      }
    },
    async viderPanier() {
      this.isComponentViderPanier = true;
    },
    changeIsOpen() {
      this.isOpen = !this.isOpen;
    },
    creerReseauPersonnalise() {
      const panneauxLcSelectionne = this.panier.produits.panneauxLc.filter((el) => {
        return el.selected;
      });
      const reseauTempoSelectionne = this.panier.produits.reseauxTempo.filter((el) => {
        return el.selected;
      });
      const reseauLcSelectionne = this.panier.produits.reseauxLc.filter((el) => {
        return el.selected;
      });
      const panneauxNumeriquesSelectionne = this.panier.produits.panneauxNumeriques.filter((el) => {
        return el.selected;
      });
      const reseauxNumeriquesSelectionne = this.panier.produits.reseauxNumeriques.filter((el) => {
        return el.selected;
      });
      if (panneauxLcSelectionne.length ||
        reseauTempoSelectionne.length ||
        reseauLcSelectionne.length ||
        panneauxNumeriquesSelectionne.length ||
        reseauxNumeriquesSelectionne.length) {
        this.actionsCreerReseauPersonnalise();
      } else {
        gestionErreur('Aucun produit sélectionné');
      }
    },
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/index.vue